<template>
    <div class="d-flex flex-column mb-3">
        <label for="share_emails">Add Project Members</label>
        <div class="d-flex gap-2 align-items-center">

            <input
                type="text"
                class="form-control"
                id="share_emails"
                name="emails"
                v-model="form.emails"
                placeholder="name@example.com"
            />

            <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"
                data-bs-auto-close="outside" aria-expanded="false" v-text="form.permission.toTitleCase()"></button>
            <ul class="dropdown-menu dropdown-menu-end">
                <div class="list-group list-group-checkable d-grid gap-2 border-0 w-auto">
                    <input class="list-group-item-check pe-none" type="radio" :name="`collaboratorMarkupAccess${`_create`}${_uid}`"
                        :id="`collaboratorMarkupAccess1${`_create`}${_uid}`" value="view" @click="form.permission = 'view'"
                        :checked="form.permission === 'view'">
                    <label class="list-group-item py-3" :for="`collaboratorMarkupAccess1${`_create`}${_uid}`">
                        View
                        <span class="d-block small opacity-50" v-text="'Allow a guest to only view the project'"></span>
                    </label>

                    <input class="list-group-item-check pe-none" type="radio" :name="`collaboratorMarkupAccess${`_create`}${_uid}`"
                        :id="`collaboratorMarkupAccess2${`_create`}${_uid}`" value="comment" @click="form.permission = 'comment'"
                        :checked="form.permission === 'comment'">
                    <label class="list-group-item py-3" :for="`collaboratorMarkupAccess2${`_create`}${_uid}`">
                        Comment
                        <span class="d-block small opacity-50"
                            v-text="'Allows a guest to make comments on points of the project'"></span>
                    </label>

                    <input class="list-group-item-check pe-none" type="radio" :name="`collaboratorMarkupAccess${`_create`}${_uid}`"
                        :id="`collaboratorMarkupAccess3${`_create`}${_uid}`" value="edit" @click="form.permission = 'edit'"
                        :checked="form.permission === 'edit'">
                    <label class="list-group-item py-3" :for="`collaboratorMarkupAccess3${`_create`}${_uid}`">
                        Edit
                        <span class="d-block small opacity-50"
                            v-text="'User will have edit rights, they will also need to create an account'"></span>
                    </label>
                </div>
            </ul>
            <button class="btn btn-orange" @click="create">Invite</button>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: ['markup', 'route', 'list-id'],
    emits: ['created'],
    data() {
        return {
            form: {
                emails: null,
                permission: 'view',
                uuid: this.markup,
            }
        }
    },
    methods: {
        create() {
            axios.post(this.route, this.form)
                .then(response => {
                    this.$emit('created', response.data.collaborators)
                    // reset form values
                    this.form.emails = null;
                    this.form.permission = 'view';
                }).catch(e => console.error(e))
        }
    },
}
</script>
